import { render, staticRenderFns } from "./star-ope.vue?vue&type=template&id=32d9182e&scoped=true&"
import script from "./star-ope.vue?vue&type=script&lang=js&"
export * from "./star-ope.vue?vue&type=script&lang=js&"
import style0 from "./star-ope.vue?vue&type=style&index=0&id=32d9182e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9182e",
  null
  
)

export default component.exports